module.exports = __webpack_public_path__ + "img/265.659f1c32.png";